module.exports = __webpack_public_path__ + "img/gift.fdf3ffba.png";